import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent } from '@angular/common/http'
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LookupService } from '../services/lookup.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LookupInterceptor implements HttpInterceptor {
    constructor(private lookupService: LookupService) {

    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        if (req.method === "GET") {
            return next.handle(req).pipe(tap(
                event => {
                    if(event instanceof HttpResponse) {
                        let httpResponse: HttpResponse<any> = event;
                        
                        if(httpResponse.body.lookups) {
                            this.lookupService.loadLookups(httpResponse.body.lookups);
                        }
                    }
                }
            ))
        }

        return next.handle(req);
    }

}